module.exports = __webpack_public_path__ + "static/phone_info.be24ccf8.png";